import { connect } from 'react-redux';
import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';

import { getAllSettings } from 'shared/selectors/app-settings';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';

import { BaseAccountButton } from 'widget/components/account/account-button';
import styles from './account-button.styl';


@connect(state => ({
  appSettings: getAllSettings(state),
  currentSiteUser: getCurrentSiteUser(state),
}))
@VODBiEvents()
@VODCSSModules(styles)
export default class AccountButtonCompact extends BaseAccountButton {
  static displayName = 'AccountButtonCompact';
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/account-button/account-button.js